import { CircleCheck, CircleX, Loader2 } from "lucide-react"
import { Toaster as Sonner } from "sonner"

export function Toaster() {
	return (
		<Sonner
			position="top-right"
			offset={12}
			icons={{
				success: (
					<CircleCheck className="size-4 fill-success stroke-background" />
				),
				error: <CircleX className="size-4" />,
				loading: <Loader2 className="size-4 animate-spin" />,
			}}
			toastOptions={{
				classNames: {
					toast:
						"w-fit gap-3 rounded border px-4 py-3 text-sm font-medium shadow-lg",
					success: "!bg-background !border-border !text-foreground",
					error:
						"!bg-error-bg !border-error !text-error-foreground [&_[data-icon]>svg]:!text-error",
					loading:
						"!bg-muted !border-border !text-foreground [&_[data-icon]>svg]:!text-muted-foreground",
				},
			}}
		/>
	)
}
